const defaultRender = (value) => (value ? value : "--");

const planListColumns = [
  {
    title: "Plan Name",
    dataIndex: "name",
    render: defaultRender,
  },
  {
    title: "Total Employees",
    dataIndex: "total_user",
    render: defaultRender,
  },
  {
    title: "Duration",
    dataIndex: "duration",
    render: (value) => `${value} months`,
  },
  {
    title: "Amount",
    dataIndex: "amount",
    render: (value) => `₹ ${value}`,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: defaultRender,
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    render: defaultRender,
  },

  {
    title: "Actions",
    dataIndex: "action",
    render: defaultRender,
  },
];

export default planListColumns;
